import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { useQueryClient } from '@tanstack/react-query';
import { LinkAsButton } from '@printdeal/ui-library';

import { ServiceFactory } from '../../../../../../services/ServiceFactory';
import OrderDetailContext from '../../../contexts/OrderDetailContext';
import { dispatchAccountEvent } from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';
import { getFileDeliveryItemId } from '../../../../../../helpers/LineItems';
import { SanitizedLineItem } from '../../../../../../types/order/Order';

interface RemoveFilesButtonProps {
  orderId: string;
  lineItem: SanitizedLineItem;
}

const RemoveFilesButton = ({ orderId, lineItem }: RemoveFilesButtonProps) => {
  const { reFetchOrder } = useContext(OrderDetailContext);
  const queryClient = useQueryClient();
  const artworkLineItemId = getFileDeliveryItemId(lineItem);

  if (!reFetchOrder) {
    return null;
  }

  const removeFile = async () => {
    await queryClient.fetchQuery({
      queryKey: ['order', 'remove-file', orderId, lineItem.id],
      queryFn: () => ServiceFactory.createFileDeliveryService().removeDocumentSource(orderId, artworkLineItemId),
    });

    await reFetchOrder({});
    dispatchAccountEvent('order_detail_interaction', 'remove_file_button');
  };

  return (
    <LinkAsButton
      type="button"
      onClick={removeFile}
      variant="secondary"
      iconBefore="trashcan"
      className="pd-text-xs"
    >
      <FormattedMessage id="account.details.button.delete.file" defaultMessage="Delete file" />
    </LinkAsButton>
  );
};

export default RemoveFilesButton;
